"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _FormAddonElementRight = _interopRequireDefault(require("../FormAddonElementRight/FormAddonElementRight"));

var _FormAddonElementLeft = _interopRequireDefault(require("../FormAddonElementLeft/FormAddonElementLeft"));

var _FormAddonAddornament = _interopRequireDefault(require("../FormAddonAddornament/FormAddonAddornament"));

var _FormControlGroup = _interopRequireDefault(require("../FormControlGroup/FormControlGroup"));

var _FormFeedback = _interopRequireDefault(require("../FormFeedback/FormFeedback"));

var _FormControl = _interopRequireDefault(require("../FormControl/FormControl"));

var _FormSelect = _interopRequireDefault(require("../FormSelect/FormSelect"));

var _FormCheck = _interopRequireDefault(require("../FormCheck/FormCheck"));

var _FormRadio = _interopRequireDefault(require("../FormRadio/FormRadio"));

var _FormLabel = _interopRequireDefault(require("../FormLabel/FormLabel"));

var _FormGroup = _interopRequireDefault(require("../FormGroup/FormGroup"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  disabled: _propTypes.bool,
  feedback: _propTypes.node,
  type: _propTypes.string,
  feedbackProps: (0, _propTypes.shape)({}),
  groupProps: (0, _propTypes.shape)({}),
  helperText: _propTypes.node,
  isValid: _propTypes.bool,
  label: _propTypes.string,
  checkLabel: _propTypes.node,
  labelProps: (0, _propTypes.shape)({}),
  leftAddon: _propTypes.node,
  leftElement: _propTypes.node,
  rightAddon: _propTypes.node,
  rightElement: _propTypes.node,
  size: (0, _propTypes.oneOf)(['sm', 'md', 'lg'])
};
var defaultProps = {
  disabled: false,
  feedback: null,
  feedbackProps: {},
  groupProps: {},
  helperText: null,
  isValid: true,
  label: null,
  labelProps: {},
  leftAddon: null,
  leftElement: null,
  rightAddon: null,
  rightElement: null,
  checkLabel: null,
  type: 'text',
  size: 'md'
};
var FormField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      feedback = _ref.feedback,
      leftAddon = _ref.leftAddon,
      rightAddon = _ref.rightAddon,
      leftElement = _ref.leftElement,
      rightElement = _ref.rightElement,
      checkLabel = _ref.checkLabel,
      helperText = _ref.helperText,
      feedbackProps = _ref.feedbackProps,
      labelProps = _ref.labelProps,
      groupProps = _ref.groupProps,
      props = _objectWithoutProperties(_ref, ["disabled", "label", "feedback", "leftAddon", "rightAddon", "leftElement", "rightElement", "checkLabel", "helperText", "feedbackProps", "labelProps", "groupProps"]);

  var content = null;
  var haveAddons = leftAddon || rightAddon || leftElement || rightElement;

  switch (props.type) {
    case 'radio':
      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormRadio["default"], _objectSpread({
        label: checkLabel,
        disabled: disabled
      }, props));
      break;

    case 'checkbox':
      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormCheck["default"], _objectSpread({
        label: checkLabel,
        disabled: disabled
      }, props));
      break;

    case 'select':
      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormSelect["default"], _objectSpread({
        disabled: disabled
      }, props));
      break;

    default:
      content = haveAddons ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControlGroup["default"], {
        size: props.size,
        children: [leftAddon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormAddonAddornament["default"], {
          children: leftAddon
        }), leftElement && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormAddonElementLeft["default"], {
          children: leftElement
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl["default"], _objectSpread({
          disabled: disabled
        }, props)), rightElement && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormAddonElementRight["default"], {
          children: rightElement
        }), rightAddon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormAddonAddornament["default"], {
          children: rightAddon
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl["default"], _objectSpread({
        disabled: disabled
      }, props));
      break;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormGroup["default"], _objectSpread(_objectSpread({
    ref: ref
  }, groupProps), {}, {
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormLabel["default"], _objectSpread(_objectSpread({
      disabled: disabled
    }, labelProps), {}, {
      children: label
    })), content, (helperText || feedback) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormFeedback["default"], _objectSpread(_objectSpread({
      type: !props.isValid ? 'invalid' : 'info'
    }, feedbackProps), {}, {
      children: props.isValid ? helperText : feedback
    }))]
  }));
});
FormField.displayName = 'FormField';
FormField.propTypes = propTypes;
FormField.defaultProps = defaultProps;
var _default = FormField;
exports["default"] = _default;

//# sourceMappingURL=FormField.js.map